// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__3jOZV","content":"GlobalSearch_content__1vId6"};